import PropTypes from 'prop-types';

import { prepareChartData, calculateBarPositions, COLOR_PALETTES, createTicks } from '@/utils/pathwayTemplateUtils';

import EmptyState from './EmptyState';
import ChartBars from './ChartBars';
import ChartAxis from './ChartAxis';
import ChartLegend from './ChartLegend';

const SharedStackedBarChart = ({
  items,
  unit,
  type = 'costs',
  title = 'Chart',
  emptyMessage = 'No data available',
}) => {
  const { scaleMin, scaleMax, hasNegativeValues } = prepareChartData(items);
  const colors = COLOR_PALETTES[type];

  if (!items || items.length === 0) {
    return <EmptyState title={title} emptyMessage={emptyMessage} />;
  }

  const totalRange = scaleMax - scaleMin;
  const zeroLinePosition = hasNegativeValues ? (Math.abs(scaleMin) / totalRange) * 100 : 0;
  const barPositions = calculateBarPositions(items, totalRange, zeroLinePosition);
  const ticks = createTicks(scaleMin, scaleMax);
  const tickTemplate = label => {
    if (type === 'costs') {
      return `$${label} `;
    }
    return label;
  };

  return (
    <div>
      <ChartBars
        colors={colors}
        barPositions={barPositions}
        hasNegativeValues={hasNegativeValues}
        zeroLinePosition={zeroLinePosition}
        unitString={unit}
      />

      <ChartAxis ticks={ticks} title={title} unitString={unit} tickTemplate={tickTemplate} />

      <ChartLegend items={items} colors={colors} />
    </div>
  );
};

SharedStackedBarChart.propTypes = {
  unit: PropTypes.string,
  items: PropTypes.array,
  type: PropTypes.oneOf(['costs', 'emissions']),
  title: PropTypes.string,
  emptyMessage: PropTypes.string,
};

export default SharedStackedBarChart;
